export const EMPTY_MESSAGE = { message: null };
